import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

function PantallaCargaGenerica() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 20, background: 'var(--color-bg)' }}>
      <div style={{ width: 70, height: 70, borderRadius: 20, background: 'linear-gradient(135deg,#cfd363,#ffffff)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, animation: 'pulse 1.5s infinite', overflow: 'hidden' }}>
  <img
    src="/icon.png"
    alt="Calypso"
    style={{ width: '65%', height: '65%', objectFit: 'contain' }}
  />
</div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--color-text)', marginBottom: 6 }}>
          <span className="app-title">Calypso</span>
        </div>
        <div style={{ fontSize: 14, color: 'var(--color-muted)' }}>Actualizando base de Datos...</div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{ width: 10, height: 10, borderRadius: '50%', background: '#cfd363', animation: `bounce 0.6s infinite ${i * 0.15}s` }} />
        ))}
      </div>
      <style>{`
        @keyframes pulse { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.08);opacity:0.85} }
        @keyframes bounce { 0%,80%,100%{transform:translateY(0);opacity:0.5} 40%{transform:translateY(-8px);opacity:1} }
      `}</style>
    </div>
  )
}

export default function ProtectedRoute({ children }) {
  const { ready, session } = useAuth()
  if (!ready) return <PantallaCargaGenerica />
  if (!session) return <Navigate to="/login" replace />
  return children
}